(function() {
  function initGalleryCarousel(wrap) {
    const gallery = wrap.querySelector('.unfazed-gallery');
    const dots = wrap.querySelectorAll('.unfazed-gallery__dot');
    if (!gallery || dots.length === 0) return;

    let scrollTimeout;

    // Click on dot → scroll to that cell
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        const index = parseInt(dot.getAttribute('data-dot-index'), 10);
        const cellWidth = gallery.clientWidth;
        gallery.scrollTo({
          left: index * cellWidth,
          behavior: 'smooth'
        });
      });
    });

    // Scroll → update active dot
    gallery.addEventListener('scroll', function() {
      window.cancelAnimationFrame(scrollTimeout);
      scrollTimeout = window.requestAnimationFrame(function() {
        const cellWidth = gallery.clientWidth;
        if (cellWidth === 0) return;
        const index = Math.round(gallery.scrollLeft / cellWidth);
        dots.forEach(function(dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.unfazed-gallery-wrap').forEach(initGalleryCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();